import { createFileRoute } from '@tanstack/react-router'
import { LegalPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/it/cookies')({
  loader: () =>
    loadPageData({
      data: { kind: 'legal', locale: 'it', params: { legalKind: 'cookies' } },
    }),
  head: () => staticRouteHead('cookies', 'it'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <LegalPage kind="cookies" />
    </CatalogProvider>
  )
}
